import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';

function transformFromDiscoveryToSearch(hits) {
  return hits.map(function (hit) {
    return _objectSpread2(_objectSpread2({}, hit), {}, {
      title: hit.name,
      imageUrl: hit.defaultImageUrl,
      landingUrl: hit.platformUrl,
      _highlightResult: _objectSpread2(_objectSpread2({}, hit._highlightResult), {}, {
        title: hit._highlightResult.name
      }),
      searchFields: {
        publiclyAvailable: hit.availabilityState === 'Public',
        aka: hit.f_aka_ss,
        descriptor: hit.f_descriptors_ss,
        useCase: hit.f_useCases_ss,
        altSpelling: hit.f_alternativeSpellings_ss,
        galleryCategories: hit.f_galleryCategories_ss,
        tags: [],
        queries: []
      }
    });
  });
}

export { transformFromDiscoveryToSearch };
//# sourceMappingURL=transformFromDiscoveryToSearch.js.map
